import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface NewsArticle {
  id: string;
  title: string;
  url: string;
  source: string;
  date: string;
}

// Mock data - would normally come from Google Alerts API
const MOCK_NEWS = [
  {
    id: '1',
    title: 'New Social Media Trends Emerging in 2024',
    url: '#',
    source: 'TechCrunch',
    date: '2024-03-20',
  },
  {
    id: '2',
    title: 'Instagram Launches New Features for Creators',
    url: '#',
    source: 'Social Media Today',
    date: '2024-03-19',
  },
  {
    id: '3',
    title: 'The Rise of Short-Form Video Content',
    url: '#',
    source: 'Marketing Weekly',
    date: '2024-03-18',
  },
] as NewsArticle[];

export const NewsJackingCard = (): ReactElement => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % MOCK_NEWS.length);
      }
    }, 5000); // Rotate every 5 seconds

    return () => clearInterval(interval);
  }, [isPaused]);

  const handleNewsClick = (article: NewsArticle) => {
    navigate('/reactive', { state: { article } });
  };

  const currentArticle = MOCK_NEWS[currentIndex];

  return (
    <Card
      className="p-5 h-max w-full"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}>
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h2 className="text-lg font-semibold">Latest News</h2>
        </motion.div>
        <div
          key={currentArticle.id}
          className="cursor-pointer"
          onClick={() => handleNewsClick(currentArticle)}>
          <h4 className="font-medium text-lg">{currentArticle.title}</h4>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span>{currentArticle.source}</span>
            <span>•</span>
            <span>{new Date(currentArticle.date).toLocaleDateString()}</span>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-4">
          {MOCK_NEWS.map((_, index) => (
            <div
              key={index}
              className={`h-1 rounded-full transition-all ${
                index === currentIndex
                  ? 'w-8 bg-primary'
                  : 'w-2 bg-muted-foreground/20'
              }`}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};
